import React from 'react'
import { SvgIcon } from '../svg-icon'
/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.DefaultProps}
 */
const defaultProps = {
    viewBoxSize: 24
}
/**
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <WeatherCloudHailIcon width={12} />
 */
export const WeatherCloudHailIcon = props => (
    <SvgIcon {...props}>
        <path d="M12.5 22.95L11.175 21.625L12.5 20.3L13.825 21.625L12.5 22.95ZM9.05 21.45L8.175 20.575L10.95 17.8L11.825 18.675L9.05 21.45ZM15.5 19.95L14.175 18.625L15.5 17.3L16.825 18.625L15.5 19.95ZM6.5 19.95L5.175 18.625L6.5 17.3L7.825 18.625L6.5 19.95ZM7.25 15.5C5.80227 15.5 4.56533 14.9873 3.5392 13.962C2.51307 12.9367 2 11.7007 2 10.2541C2 8.93471 2.47083 7.75833 3.4125 6.725C4.35417 5.69167 5.525 5.125 6.925 5.025C7.45833 4.09167 8.1625 3.35417 9.0375 2.8125C9.9125 2.27083 10.9035 2 12.0106 2C13.5202 2 14.7875 2.47917 15.8125 3.4375C16.8375 4.39583 17.4667 5.58333 17.7 7C19.0167 7.06667 20.0625 7.5125 20.8375 8.3375C21.6125 9.1625 22 10.1302 22 11.2406C22 12.4135 21.5868 13.4167 20.7604 14.25C19.934 15.0833 18.9305 15.5 17.75 15.5H7.25ZM7.25 14H17.75C18.52 14 19.1708 13.7292 19.7025 13.1875C20.2342 12.6458 20.5 11.9958 20.5 11.2375C20.5 10.4792 20.2342 9.83333 19.7025 9.3C19.1708 8.76667 18.52 8.5 17.75 8.5H16.25V7.75C16.25 6.56667 15.8375 5.5625 15.0125 4.7375C14.1875 3.9125 13.1851 3.5 12.0053 3.5C11.1473 3.5 10.3652 3.72917 9.65912 4.1875C8.95304 4.64583 8.43333 5.26667 8.1 6.05L7.9 6.5H7.2C6.16667 6.53333 5.29167 6.91161 4.575 7.63483C3.85833 8.35804 3.5 9.22857 3.5 10.2464C3.5 11.2821 3.86608 12.1667 4.59823 12.9C5.33036 13.6333 6.21428 14 7.25 14Z" />
    </SvgIcon>
)

WeatherCloudHailIcon.defaultProps = defaultProps
